import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';
import { DeviceSyncStatus } from '@era/locations-sdk';

export function selectDeviceSyncStatusId(status: DeviceSyncStatus) {
  return status.udid;
}

export const adapter: EntityAdapter<DeviceSyncStatus> = createEntityAdapter<DeviceSyncStatus>({
  selectId: selectDeviceSyncStatusId,
});

export type DeviceSyncStatusState = EntityState<DeviceSyncStatus>;

export const initialState: DeviceSyncStatusState = adapter.getInitialState();
